import React, { createContext, useContext, useState, useCallback } from 'react'

export type BannerAction = {
  label: string
  action: () => void
}

export type Banner = {
  message: string
  action?: BannerAction
}

export type BannerContextType = {
  banner: Banner | null
  showBanner: (message: string, action: BannerAction) => void
  hideBanner: () => void
}

export const BannerContext = createContext<BannerContextType>({
  banner: null,
  showBanner: () => null,
  hideBanner: () => null,
})

const BannerProvider: React.FC = ({ children }) => {
  const [banner, setBanner] = useState<Banner | null>(null)
  const showBanner = useCallback((message: string, action?: BannerAction) => {
    setBanner({ message, action })
  }, [])

  const hideBanner = useCallback(() => {
    setBanner(null)
  }, [])

  const contextValue = {
    banner,
    showBanner,
    hideBanner,
  }
  return <BannerContext.Provider value={contextValue}>{children}</BannerContext.Provider>
}

export default BannerProvider

export const useBanner = (): BannerContextType => useContext(BannerContext)
